module.exports = __webpack_public_path__ + "static/media/ic_share_activate.953a1748.svg";